module.exports = __webpack_public_path__ + "media/images/flags/32/Turkey-27d1c7c95ef6ebd42d506ecb8e62f16e.png";